// extracted by mini-css-extract-plugin
module.exports = {"classic-arrow":"style_classic-arrow__D0mw0","classic-arrow--gray":"style_classic-arrow--gray__a0FNZ","classic-arrow--left":"style_classic-arrow--left__Bkbqv"};